import React, { useEffect } from 'react';
import styled from 'styled-components';
import sharedStyles from '@repo/ui-components/styles';
import breakpoints from '@repo/ui-components/breakpoints';
import type { SanitySupportArticleVideo } from '@repo/models/gatsby-graphql-types';
import SupportArticleText from './SupportArticleText';

export const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const VideoWrapper = styled.div`
  flex-basis: 50%;

  lite-youtube {
    border: none;
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }

  @media (min-width: ${breakpoints.md}) {
    lite-youtube {
      width: 70%;
    }
  }
`;

const AnnotationWrapper = styled.div`
  padding-top: ${sharedStyles.spacing['spacing-md']};
  text-align: center;
`;

const CaptionWrapper = styled.h3`
  text-align: center;
`;

interface SupportArticleVideoProps {
  section: SanitySupportArticleVideo;
}

function SupportArticleVideo({ section }: Readonly<SupportArticleVideoProps>) {
  useEffect(() => {
    if (globalThis.window !== undefined) {
      import('lite-youtube-embed');
    }
  }, []);

  return (
    <VideoContainer>
      <VideoWrapper>
        {section?.video?.caption && (
          <CaptionWrapper>{section?.video?.caption}</CaptionWrapper>
        )}
        <lite-youtube
          title={section?.video?.caption}
          videoid={section?.video?.id}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            backgroundImage: `url('https://i.ytimg.com/vi/${section?.video?.id}/maxresdefault.jpg')`,
          }}
          params="rel=0&listType=playlist&loop=1&showinfo=0&iv_load_policy=30&start=0&end=0"
        />
      </VideoWrapper>
      <AnnotationWrapper>
        <SupportArticleText text={section?.annotation?.text} />
      </AnnotationWrapper>
    </VideoContainer>
  );
}

export default SupportArticleVideo;
